<main>

    <div class="form">
        <form [formGroup]="form" (submit)="trocarSenha()">
            <h1>Alterar Senha</h1>

            <mat-form-field appearance="outline">
                <mat-label>Senha Atual *</mat-label>
                <input #Senha formControlName="Senha" type="password" matInput>
                <mat-error>
                    Campo Senha está inválido ou vazio
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Nova Senha *</mat-label>
                <input #Senha formControlName="NovaSenha" type="password" matInput>
                <mat-error>
                    Mínimo de 6 caracteres
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Confirmação Senha *</mat-label>
                <input #Senha formControlName="ConfirmarSenha" type="password" matInput>
                <mat-error>
                    As senhas devem ser iguais
                </mat-error>
            </mat-form-field>

            <button mat-flat-button color="primary" class="text-white" type="submit">Confirmar</button>
            
        </form>
    </div>
</main>
